import React from 'react';
import { Phone, MapPin, Clock, Users, Calendar, Train, Droplets } from 'lucide-react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  const details = [{
    icon: <Phone className="w-5 h-5" data-id="element-187" />,
    label: t('finalCta.l1'),
    value: '(347) 605-8521'
  }, {
    icon: <Clock className="w-5 h-5" data-id="element-188" />,
    label: t('finalCta.l2'),
    value: t('finalCta.v2')
  }, {
    icon: <Users className="w-5 h-5" data-id="element-189" />,
    label: t('finalCta.l3'),
    value: t('finalCta.v3')
  }, {
    icon: <MapPin className="w-5 h-5" data-id="element-190" />,
    label: t('finalCta.l4'),
    value: t('finalCta.v4')
  }, {
    icon: <Calendar className="w-5 h-5" data-id="element-191" />,
    label: t('finalCta.l5'),
    value: t('finalCta.v5')
  }, {
    icon: <Train className="w-5 h-5" data-id="element-192" />,
    label: t('finalCta.l6'),
    value: t('finalCta.v6')
  }, {
    icon: <Droplets className="w-5 h-5" data-id="element-193" />,
    label: t('finalCta.l7'),
    value: t('finalCta.v7')
  }];
  return <Section className="bg-barber-black" data-id="element-194">
      <div className="max-w-4xl mx-auto" data-id="element-195">
        <div className="text-center mb-12" data-id="element-196">
          <div className="inline-block bg-barber-red text-white font-heading font-bold text-xl md:text-2xl tracking-widest uppercase px-8 py-2 rounded-sm mb-8 animate-pulse" data-id="element-197">
            {t('finalCta.banner')}
          </div>
          <h2 className="font-heading text-5xl md:text-6xl font-bold text-barber-text uppercase mb-4" data-id="element-198">
            VillaCon<span className="text-barber-gold" data-id="element-199">BarberShop</span>
          </h2>
          <p className="text-2xl text-barber-muted" data-id="element-200">
            926A East Tremont Ave, Bronx, NY 10460
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-201">
          <div className="bg-barber-gray border border-barber-lightGray rounded-sm p-6 md:p-8" data-id="element-202">
            <h3 className="font-heading text-2xl font-bold text-barber-text uppercase mb-6 border-b border-barber-lightGray pb-4" data-id="element-203">
              {t('finalCta.info')}
            </h3>
            <div className="space-y-4" data-id="element-204">
              {details.map((detail, index) => <div key={index} className="flex items-center gap-4" data-id="element-205">
                  <div className="text-barber-gold bg-barber-gold/10 p-2 rounded-sm" data-id="element-206">
                    {detail.icon}
                  </div>
                  <div data-id="element-207">
                    <p className="text-sm text-barber-muted uppercase tracking-wider" data-id="element-208">
                      {detail.label}
                    </p>
                    <p className="text-barber-text font-medium" data-id="element-209">
                      {detail.value}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="space-y-4" data-id="element-210">
            <p className="text-2xl text-barber-text font-light italic mb-8 text-center md:text-left" data-id="element-211">
              {t('finalCta.closing')}
            </p>
            <a href="tel:3476058521" className="block w-full bg-barber-red hover:bg-barber-redHover text-white font-heading font-bold text-xl tracking-wider py-5 rounded-sm transition-colors text-center shadow-[0_0_20px_rgba(196,30,36,0.3)]" data-id="element-212">
              {t('finalCta.b1')}
            </a>
            <a href="tel:3476058521" className="block w-full bg-barber-gold hover:bg-barber-goldHover text-barber-black font-heading font-bold text-xl tracking-wider py-4 rounded-sm transition-colors text-center" data-id="element-213">
              {t('finalCta.b2')}
            </a>
            <a href="tel:3476058521" className="block w-full bg-barber-gray hover:bg-barber-lightGray border border-barber-lightGray text-barber-text font-heading font-bold text-lg tracking-wider py-4 rounded-sm transition-colors text-center" data-id="element-214">
              {t('finalCta.b3')}
            </a>
            <div className="grid grid-cols-2 gap-4" data-id="element-215">
              <a href="tel:3476058521" className="block w-full bg-barber-gray hover:bg-barber-lightGray border border-barber-lightGray text-barber-text font-heading font-bold text-sm md:text-base tracking-wider py-4 rounded-sm transition-colors text-center" data-id="element-216">
                {t('finalCta.b4')}
              </a>
              <a href="tel:3476058521" className="block w-full bg-barber-gray hover:bg-barber-lightGray border border-barber-lightGray text-barber-text font-heading font-bold text-sm md:text-base tracking-wider py-4 rounded-sm transition-colors text-center" data-id="element-217">
                {t('finalCta.b5')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}